import React from 'react';
import ResponsiveHeroImage from '@/components/ResponsiveHeroImage';
import HeroShowcase from '@/components/HeroShowcase';

const HeroSection: React.FC = () => {
  return (
    <section 
      className="relative h-[calc(100svh-var(--nav-h))] min-h-[calc(100svh-var(--nav-h))] overflow-hidden" 
      role="banner"
      aria-label="Hero section"
    >
      {/* Background Image Container */}
      <div className="absolute inset-0 h-full overflow-hidden">
        <ResponsiveHeroImage />
      </div>
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/40" />
      
      {/* Content - flex layout anchors showcase to bottom */}
      <div className="relative z-10 w-full h-full flex items-end px-4 sm:px-[8vw] pb-[clamp(12px,5vh,48px)]">
        <HeroShowcase />
      </div>
    </section>
  );
};

export default HeroSection;
